import { useSelector } from 'react-redux';
import { snippetsModel } from '../../../features/snippets';
import { useSnippetsPermissions } from '../../../features/teams';
import { useSnippetsActions } from './use-snippets-actions';

export const useSnippetsExists = () => {
  const { isCanManageOrCreatePersonalSnippets } = useSnippetsActions();
  const { isCanCreatePersonalSnippets, isCanManageCategories } =
    useSnippetsPermissions();

  const categories = useSelector(snippetsModel.selectors.selectCategories);
  const personalSnippets = useSelector(
    snippetsModel.selectors.selectPersonalSnippets
  );
  const draftSnippets = useSelector(
    snippetsModel.selectors.selectDraftSnippets
  );

  const isPersonalSnippetsAvailable =
    isCanCreatePersonalSnippets && personalSnippets.length > 0;

  const isDraftSnippetsAvailable =
    isCanManageOrCreatePersonalSnippets && draftSnippets.length > 0;

  const isCategoriesAvailable =
    (isCanManageCategories && categories.length > 0) ||
    categories.some((c) => c.snippets.length > 0);

  const isDataAvailable =
    isCategoriesAvailable ||
    isPersonalSnippetsAvailable ||
    isDraftSnippetsAvailable;

  return isDataAvailable;
};
